export var tableHeaderContainer = {
  padding: '0.8em 1.5em'
};
export var primaryRow = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-end',
  gap: '0.8em'
};
export var advancedRow = function advancedRow(theme) {
  return {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    gap: '0.8em',
    paddingTop: '0.8em',
    marginTop: '0.8em',
    borderTop: "1px solid ".concat(theme.gray100)
  };
};
export var filterToggle = function filterToggle(theme) {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5em',
    cursor: 'pointer',
    padding: '0.5em 1em',
    fontSize: '1.2rem',
    fontWeight: 500,
    color: theme.gray500,
    border: "1px solid ".concat(theme.gray200),
    backgroundColor: 'transparent',
    transition: 'all 0.15s ease',
    whiteSpace: 'nowrap',
    minHeight: '3.6rem',
    '&:hover': {
      color: theme.primary,
      borderColor: theme.primary
    },
    '& i': {
      fontSize: '1.4rem',
      transition: 'transform 0.2s ease'
    }
  };
};
export var filterBadge = function filterBadge(theme) {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '1.8rem',
    height: '1.8rem',
    padding: '0 0.4em',
    fontSize: '1rem',
    fontWeight: 600,
    color: theme.mode === 'dark' ? theme.white : theme.white,
    backgroundColor: theme.primary,
    lineHeight: 1
  };
};
export var filterField = {
  flex: '1 1 180px',
  maxWidth: 240,
  minWidth: 140
};
export var filterFieldWide = {
  flex: '2 1 280px',
  maxWidth: 400,
  minWidth: 200
};
export var filterFieldAuto = {
  flex: '0 0 auto'
};